<template lang="pug">
  .level-two-data
    .relationship-table
      credential-block(
        :title="`Legal Entity Credentials (${credentialCount})`",
        root-class="children-block", :tooltip="tooltips.leCredential" :is-children="true")
        .children(v-if="credentialCount !== 0")
          //- p.name {{companyName}}

          credential-details(
            v-for="(credential, i) in credentials",
            :key="i",
            :credential="credential",
          )
        .empty(v-else-if="hasErrors")
          p.info {{ error }}
        .empty(v-else)
          p.info No credentials data available for {{companyName}}
        lei-popover()
          show-more(v-if="showCredentialMoreBtn", @show-more="showMorePages()")
</template>
<script>
import { mapActions, mapGetters, mapState, } from 'vuex'
import Graph from '../../record-details/Graph'
import CredentialDetails from './CredentialDetails'
import LeiBtn from '../../lei-components/LeiBtn'
import ShowMore from '../ShowMore'
import LeiPopover from '../../lei-components/LeiPopover'
import credential from '../../../constants/tooltips/credentials'
import CredentialBlock from './CredentialBlock'

export default {
  components: {
    CredentialBlock,
    ShowMore,
    LeiBtn,
    CredentialDetails,
    Graph,
    LeiPopover,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      tooltips: credential,
      lastpage: 1,
      currentpage: 1,
    }
  },
  computed: {
    ...mapState('credential', [
      'credentials',
      'pagination',
      'hasErrors',
      'error',
    ]),
    ...mapState('record', [ 'record', ]),
    ...mapGetters('record', [ 'companyName', 'lei', ]),
    credentialCurrentPage () {
      return this.pagination.currentPage
    },
    credentialLastPage  () {
      return this.pagination.lastPage
    },
    showCredentialMoreBtn () {
      return this.credentialCurrentPage < this.credentialLastPage
    },
    credentialCount () {
      return this.pagination.total
    },
  },
  methods: {
    showMorePages () {
      this.currentpage++
      this.getCredentials({
        lei: this.lei,
        page: this.currentpage,
      })
    },
    ...mapActions('credential', [ 'getCredentials', ]),
  },
}
</script>



// WEBPACK FOOTER //
// src/components/record-details/credentials/Credentials.vue